import styled from 'styled-components';

export const Banner = styled.div`
  background: #e9f2ff;
  border-bottom: 1px solid #c8dcff;
  color: #1f2937;
  padding: 10px 40px 10px 15px;
  margin: 0;
  text-align: center;
  font-size: 14px;
  line-height: 1.5;
  box-shadow:
    0 1px 2px rgb(0 0 0 / 4%),
    0 2px 6px rgb(0 0 0 / 6%);
  z-index: 1000;
  position: relative;

  @media (prefers-color-scheme: dark) {
    background: #0f172a;
    border-bottom-color: #1e293b;
    color: #e5e7eb;
    box-shadow: 0 1px 2px rgb(0 0 0 / 50%);
  }

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 8px 40px 8px 12px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #1f2937;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }

  @media (prefers-color-scheme: dark) {
    color: #e5e7eb;
  }

  @media (max-width: 768px) {
    right: 10px;
    font-size: 20px;
    width: 20px;
    height: 20px;
  }
`;
